module.exports = __webpack_public_path__ + "static/media/minus-circle.0b1c07e9.svg";